import { type FC } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type SidebarAppProps } from '../../sidebar/sidebarAppComponentProps.type';
import { setMapSettingsInitialExpandedIndices } from '../../store/frontendState/leftSidebar/leftSidebar.actionCreators';
import { useFrontendStateLeftSidebarMapSettingsInitialExpandedIndicesSelector } from '../../store/frontendState/leftSidebar/leftSidebar.selectors';
import { useIsMapSettingsSyncInProgressSelector } from '../../store/frontendState/processing/processing.selectors';
import { useBaseMapSettings } from './accordion/baseMap/useBaseMapSettings';
import { useMapMarkersGraphicsSettings } from './accordion/mapMarkersGraphics/useMapMarkersGraphicsSettings';
import { useOtherSettingsSettings } from './accordion/otherSettings/useOtherSettingsSettings';
import { useSharedPresentationalMapsSettings } from './accordion/sharedPresentationalMaps/useSharedPresentationalMapSettings/useSharedPresentationalMapsSettings';
import { MapSettingsComponent } from './mapSettings.component';

const emptyArray: readonly number[] = [];

export const MapSettingsContainer: FC<SidebarAppProps> = props => {
  const dispatch = useDispatch();
  const isMapSettingsLoading = useSelector<boolean>(state => state.map.mapSettings.isLoading);
  const isMapInfoLoading = useSelector<boolean>(state => state.map.mapInfo.isLoading);
  const isMapSettingsSyncInProgress = useIsMapSettingsSyncInProgressSelector();
  const initialExpandedIndices = useFrontendStateLeftSidebarMapSettingsInitialExpandedIndicesSelector();
  const mapStylesProps = useBaseMapSettings();

  const handleExpandedIndicesApplied = () =>
    dispatch(setMapSettingsInitialExpandedIndices(null));

  const mapMarkersGraphicsProps = useMapMarkersGraphicsSettings();
  const sharedPresentationalMapsProps = useSharedPresentationalMapsSettings();
  const otherSettingsProps = useOtherSettingsSettings();

  return (
    <MapSettingsComponent
      {...props}
      baseMapSettingsProps={mapStylesProps}
      initialExpandedIndices={initialExpandedIndices ?? emptyArray}
      isLoading={isMapSettingsLoading || isMapInfoLoading || isMapSettingsSyncInProgress}
      onInitialExpandedIndicesApplied={handleExpandedIndicesApplied}
      otherSettingsProps={otherSettingsProps}
      sharedPresentationMapProps={sharedPresentationalMapsProps}
      {...mapMarkersGraphicsProps}
    />
  );
};
